<template>
  <div class="aidrama-h5">
    <template v-if="from != 'introDetail'">
      <div id="block"></div>
      <Header />
    </template>
    <Banner :bannerList="bannerList" />
    <Box1 />
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Footer />
  </div>
</template>

<script>
import Banner from "./Banner.vue";
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";

export default {
  name: "AidramaPage",
  components: {
    Banner,
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Header,
    Footer,
  },
  data() {
    return {
      bannerList: [
        {
          imageUrl: require("../../../assets/coursePage/aidrama/banner.png"),
        },
      ],
      from: "",
    };
  },
  mounted() {
    this.from = this.getQueryString("from");
    if (window.zhuge) {
      window.zhuge.track("进入_传智AI漫剧页", {
        终端: "H5",
        专题页名称: "传智AI漫剧页",
      });
    }
  },
};
</script>

<style scoped lang="scss">
.aidrama-h5 {
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

#block {
  width: 100%;
  height: 88px;
}
</style>
